import { AsyncPipe } from "@angular/common";
import { Component, forwardRef, inject, OnInit, signal } from "@angular/core";
import { FormGroupPipe } from "../../../../../shared/pipes/form-group.pipe";
import { InventoryActionFormComponent } from "../../../../../shared/common-forms/inventory-action-form/inventory-action-form.component";
import { MatButtonModule } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatToolbarModule } from "@angular/material/toolbar";
import { FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { InventoryActionService } from "../../../../../services/inventory-action.service";
import { catchError, EMPTY } from "rxjs";
import { MatSnackBar } from "@angular/material/snack-bar";
import { generateInventoryActionFormGroup, InventoryAction } from "../../../../../models/inventory_action.model";

@Component({
  selector: 'app-buy-order-edit-form',
  templateUrl: './buy-order-edit-form.component.html',
  styleUrl: './buy-order-edit-form.component.scss',
  imports: [
    FormGroupPipe,
    forwardRef(() => InventoryActionFormComponent),
    MatButtonModule,
    MatDatepickerModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatToolbarModule,
    ReactiveFormsModule,
  ]
})
export class BuyOrderEditFormComponent implements OnInit {

  protected loading = signal(false);

  public readonly data = inject(MAT_DIALOG_DATA);

  public readonly fb = inject(FormBuilder);
  form: FormGroup = this.fb.group({
    extra_params: this.fb.group({
      required_delivery_date: [null],
    }),
    inventory_action_products: this.fb.array([]),
  });

  private buyOrder = signal<InventoryAction>(undefined);


  private readonly inventoryActionService = inject(InventoryActionService);

  private readonly matDialogRef = inject(MatDialogRef<BuyOrderEditFormComponent>);

  private readonly snackbar = inject(MatSnackBar);


  get title() {
    return this.data.title || 'Editar Orden de Compra Nº ' + this.buyOrder()?.correlative_id;
  }


  get formValid() {
    return this.form.valid && this.inventoryActionProducts?.value?.length > 0;
  }

  get requiredDeliveryDate() {
    return this.form.get('extra_params.required_delivery_date') as FormControl;
  }

  get inventoryActionProducts(): FormArray {
      return this.form.get('inventory_action_products') as FormArray;
    }
  
  set inventoryActionProducts(products: any) {
    this.form.controls.inventory_action_products = products;
  }

  ngOnInit(): void {
    this.loading.set(true);
    this.inventoryActionService.get(this.data.id).pipe(
      catchError(() => {
        this.loading.set(false);
        this.snackbar.open('Error al cargar el pedido de compra', 'Cerrar', {
          duration: 3000,
          panelClass: 'error-snackbar',
        });
        return EMPTY;
      })
    ).subscribe((response) => {
      this.form = generateInventoryActionFormGroup(response);
      this.buyOrder.set(response);

      this.loading.set(false);
    });
  }

  protected getFormDataForSending() {
    const formData = this.form.getRawValue();

    formData.inventory_action_products = this.inventoryActionProducts.getRawValue();
    
    formData.inventory_action_products_attributes = formData.inventory_action_products.map(
      (product) => ({
        ...product,
        warehouse_id: this.form.get('warehouse_id').value,
      }),
    );

    delete formData['inventory_action_products'];

    return formData;
  }

  saveForm() {
    const formData = this.getFormDataForSending();

    this.inventoryActionService
      .update(this.data.id, formData)
      .subscribe(() => {
        this.snackbar.open('Orden de Compra actualizada', 'Cerrar', {  panelClass: 'snackbar-success', duration: 2000 });
        this.matDialogRef.close(true);
      });
  }
}
